import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'tsyringe';
import { createElement } from '@gn-audio/core/common/templating';
import { BasketEventBus } from '../../services/basket-event-bus.service';
import { BasketUIMessageComponent } from '../basket-ui-message/basket-ui-message.component';
import './basket-ui-messages.component.scss';
import template from './basket-ui-messages.component.html';
var BasketUIMessagesComponent = /** @class */ (function () {
    function BasketUIMessagesComponent(eventBus, translations) {
        var _this = this;
        this.eventBus = eventBus;
        this.translations = translations;
        this.onPushMessage = function (message) {
            if (message === void 0) { message = {}; }
            if (!message.title) {
                message.title = _this.translations.ExceptionDefaultTitle;
            }
            if (!message.text) {
                message.text = _this.translations.ExceptionDefaultText;
            }
            // Only one message at a time
            if (!!_this.component) {
                _this.component.destroy();
            }
            _this.component = new BasketUIMessageComponent();
            _this.component.render({
                container: _this.container,
                translations: _this.translations,
                data: message,
            });
        };
    }
    BasketUIMessagesComponent.prototype.register = function () {
        this.createUI();
        this.attachEvents();
    };
    BasketUIMessagesComponent.prototype.createUI = function () {
        this.container = createElement(template, {}, this.translations);
        document.body.appendChild(this.container);
    };
    BasketUIMessagesComponent.prototype.attachEvents = function () {
        this.eventBus.subscribe("push-message" /* BasketEvent.PushMessage */, this.onPushMessage);
    };
    BasketUIMessagesComponent = __decorate([
        injectable(),
        __param(1, inject("basketTranslations" /* DiToken.Translations */)),
        __metadata("design:paramtypes", [BasketEventBus, Object])
    ], BasketUIMessagesComponent);
    return BasketUIMessagesComponent;
}());
export { BasketUIMessagesComponent };
